import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='min-h-screen bg-base text-main'>
      <div className='max-w-[680px] mx-auto px-5 py-8'>
        <button
          type='button'
          onClick={() => navigate(-1)}
          className='flex items-center gap-1 text-muted mb-6 text-[13px]'
        >
          <ChevronLeft className='w-4 h-4' /> Back
        </button>

        <h1 className='text-2xl font-extrabold text-main mb-1'>Terms of Service</h1>
        <p className='text-xs text-dim mb-8'>Effective date: 13 April 2026</p>

        <div className='space-y-6 text-sm text-muted leading-relaxed'>
          <section>
            <h2 className='text-base font-bold text-main mb-2'>1. Acceptance of Terms</h2>
            <p>
              By creating a Planacle account or using any part of our service you agree to be bound
              by these Terms of Service. If you do not agree, do not use the service.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>2. Who We Are</h2>
            <p>
              Planacle is a group-planning application operated by Planacle Ltd. Contact:{' '}
              <a
                href='mailto:legal@planacle.app'
                className='text-link underline underline-offset-2'
              >
                legal@planacle.app
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>3. Eligibility</h2>
            <p>
              You must be at least 13 years old (or the minimum age of digital consent in your
              country, if higher) to use Planacle.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>4. Your Account</h2>
            <p>
              You are responsible for keeping your password secure and for all activity under your
              account. Notify us immediately at legal@planacle.app if you believe your account has
              been compromised.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>5. Acceptable Use</h2>
            <p className='mb-2'>You must not:</p>
            <ul className='list-disc list-inside space-y-1 text-muted'>
              <li>Use the service for any unlawful purpose.</li>
              <li>Harass, threaten, or harm other users.</li>
              <li>
                Attempt to gain unauthorised access to our systems or another user&apos;s data.
              </li>
              <li>Scrape or reverse-engineer the service without written consent.</li>
            </ul>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>6. AI-Generated Plans</h2>
            <p>
              Planacle uses AI to generate itinerary suggestions. These are suggestions only — we
              make no guarantee that venues are open or available. Always verify with the venue
              before booking.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>7. Disclaimer of Warranties</h2>
            <p>
              The service is provided &quot;as is&quot; without warranties of any kind. Our total
              liability to you shall not exceed £50.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>8. Governing Law</h2>
            <p>
              These Terms are governed by the laws of England and Wales. You may delete your account
              at any time via Account Settings.
            </p>
          </section>

          <section>
            <h2 className='text-base font-bold text-main mb-2'>9. Contact</h2>
            <p>
              Questions?{' '}
              <a
                href='mailto:legal@planacle.app'
                className='text-link underline underline-offset-2'
              >
                legal@planacle.app
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
